<template>
  <div class="treeBox">
    <el-input
      size="small"
      v-if="isSearch"
      :placeholder="$t('common.searchTip')"
      v-model="filterText"
    >
    </el-input>
    <el-tree
      class="filter-tree"
      :data="tree"
      :indent="0"
      node-key="label"
      :highlight-current="false"
      :props="defaultProps"
      :default-expanded-keys="treeExpandData"
      :filter-node-method="filterNode"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
      ref="tree"
    >
    </el-tree>
  </div>
</template>
<script>
export default {
  data() {
    return {
      provincialCenterId: "",
      treeExpandData: [],
      filterText: "",
      tree: [],
      defaultProps: {
        children: "children",
        label: "value",
      },
      companyId: "",
    };
  },
  props: ["isSearch", "treeData"],
  created() {
    this.init();
  },
  methods: {
    getRoleTreeRootNode(provincialCenterId) {
      this.treeExpandData.push(provincialCenterId);
    },
    init() {
      let param = {
        orgId: sessionStorage.getItem("roleData"),
        companyId: sessionStorage.getItem("companyId"),
      };
      this.$store.dispatch("tree/GET_QUERYTREE", param).then((res) => {
        if (res.data) {
          let routeParam = {};
          routeParam.id = res.data.data[0].label;
          routeParam.name = res.data.data[0].value;
          routeParam.level = res.data.data[0].level;
          this.tree = res.data.data;
          this.provincialCenterId = this.tree[0].label;
          this.getRoleTreeRootNode(this.provincialCenterId);
          this.$emit("initFun", routeParam);
        }
      });
    },
    handleNodeClick(data) {
      this.$emit("nodeClick", data);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.value.indexOf(value) !== -1;
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>

<style lang="less" scoped>
.treeBox {
  text-align: center;
  padding-top: 20px;
  /deep/.el-input {
    width: 90%;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-color: #c6cdd5;
      border-radius: 0;
      padding: 0 10px;
      background: transparent;
      color: #fff;
    }
  }
  /deep/.el-tree {
    width: 90%;
    display: inline-block;
    background-color: transparent;
    color: #fff;
    padding-top: 10px;
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background-color: rgba(74, 145, 218, 0.5);
      color: #fff;
    }
    .el-tree-node:focus > .el-tree-node__content {
      background-color: rgba(74, 145, 218, 0.5);
    }
    .el-tree-node__content:hover {
      background-color: rgba(74, 145, 218, 0.5);
      color: #fff;
    }
    .el-tree-node__label {
      font-size: 14px;
    }
    .el-tree-node__expand-icon.expanded {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    .el-tree-node__content > .el-tree-node__expand-icon {
      padding: 6px 10px;
    }
    .el-icon-caret-right:before {
      background: url("../assets/images/open.png") no-repeat 0 1px;
      content: "";
      display: block;
      width: 16px;
      height: 18px;
      font-size: 16px;
      background-size: 16px;
    }
    .el-tree-node__expand-icon.is-leaf::before {
      background: none !important;
    }
    .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
      background: url("../assets/images/close.png") no-repeat 0 1px;
      content: "";
      display: block;
      width: 16px;
      height: 18px;
      font-size: 16px;
      background-size: 16px;
    }
    .el-tree-node__expand-icon.is-leaf::before {
      background: url("../assets/images/open.png") no-repeat 0 1px;
      content: "";
      display: block;
      width: 16px;
      height: 18px;
      font-size: 16px;
      background-size: 16px;
    }
    .el-tree-node {
      position: relative;
      padding-left: 18px;
    }
    .el-tree-node:last-child:before {
      height: 34px;
    }
    .el-tree-node:before {
      border-left: none;
    }
    .el-tree-node:after {
      border-top: none;
    }
    .el-tree-node:before,
    .el-tree-node:after {
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
    }
  }
}
</style>
